// extracted by mini-css-extract-plugin
module.exports = {"days":"Movies2025_days__34AIr"};